import { useEffect, useState } from 'react';

/**
 * True once the window has scrolled past `threshold` pixels. Used to switch a sticky header from
 * its resting look to a translucent one once page content is actually passing underneath it.
 */
export const useIsScrolled = (threshold = 0): boolean => {
    const [isScrolled, setIsScrolled] = useState(() => window.scrollY > threshold);

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > threshold);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [threshold]);

    return isScrolled;
};
